module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    staticClass: "w5-vds-plan-list-filter-wrapper",
    class: _vm.action
  }, _vm._l((_vm.tabsOrdered), function(tabName, idx) {
    return (_vm.tabsData && _vm.tabsData[tabName] && _vm.tabsData[tabName].title) ? _c('span', {
      key: idx,
      staticClass: "w5-vds-plan-list-filter first",
      class: {
        'active': _vm.currentTab === tabName
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleTabChange(tabName)
        }
      }
    }, [(_vm.tabsData && _vm.tabsData[tabName] && _vm.tabsData[tabName].title) ? [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.tabsData[tabName].title)) + "\n\t\t\t\t")] : _vm._e()], 2) : _vm._e()
  }), 0), _vm._v(" "), (_vm.tabsData && _vm.tabsData['00'] && _vm.currentTab == '00') ? _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, [(_vm.tabsData['00'].list && _vm.tabsData['00'].list.length) ? _vm._l((_vm.tabsData['00'].list), function(Template, idx) {
    return (_vm.isTemplateVisible(Template)) ? _c('div', {
      key: 'temp' + idx,
      staticClass: "w5-vds-plan-list-item template_id",
      class: {
        'not-active-item': !_vm.isActiveTemplate(Template),
          'not-for-current-plan': _vm.action === 'view' && _vm.isNotTemplateForPlan(Template),
          'for-users': _vm.$store.state.user_type === 'client',
          'selected': _vm.isSelectedVersion(Template.list)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleClick(Template.name)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up"
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + Template.image,
        "width": "64"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gourp-title"
    }, [_c('strong', [_vm._v(_vm._s(Template.list.length === 1 && Template.list[0].fullName ? Template.list[0].fullName : Template.name))])])]), _vm._v(" "), (Template.list.length > 1) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id",
      class: {
        'border-none': Template.showList
      },
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "corner",
      class: {
        'for-open-block': Template.showList
      }
    }), _vm._v(" "), (Template.showList) ? _c('div', {
      staticClass: "selector"
    }, _vm._l((Template.list), function(temp, idx) {
      return (temp.version) ? _c('div', {
        class: {
          'last': idx === Template.list.length - 1,
            'not-supported': !temp || !temp.id || !temp.plans || !temp.plans.length || (_vm.action === 'view' && _vm.isNotTemplateForPlan(temp))
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.handleSelectTemplate(temp)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(temp.version) + "\n\t\t\t\t\t\t")]) : _vm._e()
    }), 0) : (_vm.isSelectedVersion(Template.list)) ? _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm.isSelectedVersion(Template.list).version))]) : _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm._f("ftc")('template/select_version')))])]) : (Template.list.length === 1) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id"
    }, [(!Template.list[0].version) ? _c('span', {
      staticClass: "item-with-only-line"
    }, [_c('div', {
      staticClass: "line"
    })]) : _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(Template.list[0].version))])]) : _vm._e()]) : _vm._e()
  }) : _c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])], 2) : _vm._e(), _vm._v(" "), (_vm.tabsData && _vm.tabsData['01'] && _vm.currentTab == '01') ? _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, [(_vm.tabsData['01'].list && _vm.tabsData['01'].list.length) ? _vm._l((_vm.tabsData['01'].list), function(Template, idx) {
    return (_vm.isTemplateVisible(Template)) ? _c('div', {
      key: 'temp' + idx,
      staticClass: "w5-vds-plan-list-item template_id",
      class: {
        'not-active-item': !_vm.isActiveTemplate(Template),
          'not-for-current-plan': _vm.action === 'view' && _vm.isNotTemplateForPlan(Template),
          'for-users': _vm.$store.state.user_type === 'client',
          'selected': _vm.isSelectedVersion(Template.list)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.handleClick(Template.name)
        }
      }
    }, [_c('div', {
      staticClass: "w5-vds-plan-list-item-up twi",
      class: {
        'full-and-round': Template.list.length <= 0 || (Template.list.length === 1 && !Template.list[0].version)
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + Template.image,
        "width": "64"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "gourp-title"
    }, [_c('strong', [_vm._v(_vm._s(Template.name))])])]), _vm._v(" "), (Template.list.length > 1) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id",
      class: {
        'border-none': Template.showList
      },
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticClass: "corner",
      class: {
        'for-open-block': Template.showList
      }
    }), _vm._v(" "), (Template.showList) ? _c('div', {
      staticClass: "selector"
    }, _vm._l((Template.list), function(temp, idx) {
      return (temp.version) ? _c('div', {
        class: {
          'last': idx === Template.list.length - 1,
            'not-supported': !temp || !temp.id || !temp.plans || !temp.plans.length || (_vm.action === 'view' && _vm.isNotTemplateForPlan(temp))
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            $event.stopPropagation();
            return _vm.handleSelectTemplate(temp)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(temp.version) + "\n\t\t\t\t\t\t")]) : _vm._e()
    }), 0) : (_vm.isSelectedVersion(Template.list)) ? _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm.isSelectedVersion(Template.list).version))]) : _c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(_vm._f("ftc")('template/select_version')))])]) : (Template.list.length === 1 && Template.list[0].version) ? _c('div', {
      staticClass: "w5-vds-plan-list-item-down template_id"
    }, [_c('span', {
      staticClass: "item-with-only-text"
    }, [_vm._v(_vm._s(Template.list[0].version))])]) : _vm._e()]) : _vm._e()
  }) : _c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])], 2) : _vm._e(), _vm._v(" "), (_vm.tabsData && _vm.tabsData['02'] && _vm.currentTab == '02') ? _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, [(_vm.tabsData['02'].list && _vm.tabsData['02'].list.length) ? _c('div', {
    staticClass: "w5-field removeRightPadding"
  }, [_c('backupChoiceComponent', {
    attrs: {
      "action": _vm.action,
      "list": _vm.tabsData['02'].list,
      "plan": _vm.currentPlan,
      "datacenters": _vm.dataCenterField && _vm.dataCenterField.list && _vm.dataCenterField.list.length ? _vm.dataCenterField.list : [],
      "dc": _vm.dataCenterField && 'value' in _vm.dataCenterField ? _vm.dataCenterField.value : (_vm.dc ? _vm.dc : null)
    },
    on: {
      "focus": _vm.onTabComponentFocus,
      "input": _vm.onSelectBackup
    },
    model: {
      value: (_vm.tabsData['02'].value),
      callback: function($$v) {
        _vm.$set(_vm.tabsData['02'], "value", $$v)
      },
      expression: "tabsData['02'].value"
    }
  })], 1) : _c('div', {
    staticClass: "empty-backup-list",
    staticStyle: {
      "width": "100%"
    }
  }, [(!_vm.dataCenterField || !_vm.dataCenterField.value) ? _c('span', {
    staticClass: "empty-message"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('datacenter/not_selected')) + "\n\t\t\t")]) : (_vm.accountField && _vm.accountField.value) ? _c('span', {
    staticClass: "empty-message"
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('service/backup_list_empty')) + "\n\t\t\t")]) : _c('span', {
    staticClass: "empty-message",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": "https://vdsina.com/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/kak-sdelat-bekap-vds-servera",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('backup/hint_how_to_make')) + "\n\t\t\t")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.tabsData && _vm.tabsData['03'] && _vm.currentTab == '03') ? _c('div', {
    staticClass: "w5-vds-plan-list-block template"
  }, [(_vm.tabsData['03'].list && _vm.tabsData['03'].list.length) ? _c('div', {
    staticClass: "w5-field removeRightPadding"
  }, [_c('isoChoiceComponent', {
    attrs: {
      "list": _vm.tabsData['03'].list
    },
    on: {
      "focus": _vm.onTabComponentFocus,
      "input": _vm.onSelectIso
    },
    model: {
      value: (_vm.tabsData['03'].value),
      callback: function($$v) {
        _vm.$set(_vm.tabsData['03'], "value", $$v)
      },
      expression: "tabsData['03'].value"
    }
  })], 1) : _c('div', {
    staticClass: "empty-backup-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "empty-message"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('iso/hint_how_to_use')) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": "https://vdsina.com/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('iso/hint_how_to_use')) + "\n\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/kak-ispolzovat-svoy-obraz-iso-v-vds",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")('iso/hint_how_to_use')) + "\n\t\t\t")]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f37cfd"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/tempNew.vue
// module id = 390
// module chunks = 0